@if (catalogEnv.env.lightboxEnabled) {
  <button mat-icon-button (click)="onOpen($event)" [title]="'catalog.lightbox.open' | transloco">
    <mat-icon>images</mat-icon>
  </button>
}
